<script setup lang="ts">
import { ICON_DEFS } from '~/data/maquette'

/** `icon(name, extraClass)` de la maquette. Le contenu SVG vient de ICON_DEFS (jamais d'une saisie). */
const props = defineProps<{ name: string, extra?: string }>()
const markup = computed(() => ICON_DEFS[props.name] ?? '')
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <svg
    v-if="markup"
    viewBox="0 0 24 24"
    :class="['icon', extra]"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    v-html="markup"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>
